export function App(): JSX.Element {
  return (
    <main className="app">
      <section className="hero">
        <h1>WorkInUK</h1>
        <p>Visa sponsorship-friendly job discovery, built on Cloudflare.</p>
        <ul>
          <li>Verified sponsor companies with simple health checks.</li>
          <li>Job ingestion pipelines coming online in later sprints.</li>
          <li>Fast Pages deployment with Workers-powered APIs.</li>
        </ul>
      </section>
    </main>
  );
}
